import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { S as SvgIcon } from './SvgIcon-CKg98T6e.js';
import { u as useStyles } from './styles-DgHH-zvF.js';
import { j as jsxRuntimeExports } from './jsx-runtime-DPHDmO8O.js';

var LoadingMode = /*#__PURE__*/function (LoadingMode) {
  LoadingMode["FullScreen"] = "fullscreen";
  LoadingMode["Static"] = "static";
  LoadingMode["Cover"] = "cover";
  return LoadingMode;
}({});

function Loading(_ref) {
  var className = _ref.className,
    _ref$mode = _ref.mode,
    mode = _ref$mode === undefined ? LoadingMode.Static : _ref$mode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
  var _useStyles = useStyles({
      backgroundColor: backgroundColor
    }),
    root = _useStyles.root,
    icon = _useStyles.icon;
  var iconName = mode === LoadingMode.FullScreen ? 'loading-fullscreen' : 'loading-inline';
  var DOM = /*#__PURE__*/jsxRuntimeExports.jsx("div", {
    className: classNames(root, className, mode),
    children: /*#__PURE__*/jsxRuntimeExports.jsx(SvgIcon, {
      name: iconName,
      className: icon
    })
  });
  return mode === LoadingMode.FullScreen ? /*#__PURE__*/createPortal(DOM, document.body) : DOM;
}

export { Loading as L, LoadingMode as a };
//# sourceMappingURL=Loading-v50GVQ0N.js.map
